






import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'PurchaseOffersBarChart'

  vue:
    props: ['data']

    components: {
      BoxChart,
    }

    data: ->
      chart: null

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        @chart = new Chart(@$refs.chart, {
          plugins: [ChartDataLabels]
          type: 'bar'
          data: {
            labels: ['Offers']
            datasets: [
              {
                label: 'Complete'
                data: [@data.past]
                backgroundColor: ChartUtility.COLORS.blue
              }
              {
                label: 'In Flight'
                data: [@data.in_flight]
                backgroundColor: ChartUtility.COLORS.purple
              }
              {
                label: 'Planned'
                data: [@data.future]
                backgroundColor: ChartUtility.COLORS.green
              }
              {
                label: 'Pending'
                data: [@data.pending]
                backgroundColor: ChartUtility.COLORS.orange
              }
            ]
          }
          options: {
            indexAxis: 'y'
            aspectRatio: 1.5
            datasets: {
              bar: {
                borderRadius: 4
                maxBarThickness: 24
              }
            }
            scales: {
              x: {
                display: false
              }
              y: {
                display: false
              }
            }
            plugins: {
              legend: {
                display: false
              }
              datalabels: {
                formatter: (value, context) =>
                  "#{@$options.filters.formatNumberShort(value)} #{context.dataset.label}"
                align: (context) =>
                  if context.dataset.data[context.dataIndex] < ChartUtility.maxDatasetValue(context) / 2
                    'end'
                  else
                    'start'
                color: (context) =>
                  if context.dataset.data[context.dataIndex] < ChartUtility.maxDatasetValue(context) / 2
                    context.dataset.backgroundColor
                  else
                    ChartUtility.COLORS.white
                anchor: 'end'
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        })

export default VueOptions.vue settings
